'use strict';
var parent = require('../../es/instance/fill');

module.exports = parent;
